module.exports = __webpack_public_path__ + "ed42bf42bddfac26730f90ca029066eb.fbx";